/**
 * Bản tiếng Anh của `#modules`. Mỗi chuỗi lấy từ thuộc tính `data-en` của CHÍNH node đó trong
 * `template.html` — không dịch mới.
 *
 * `icon`, `tint`, `beta` giống hệt bản `vi` vì chúng KHÔNG dịch được. Vẫn khai lại đầy đủ chứ
 * không dùng chung: hình dạng phải khớp, và interface khai lại tại chỗ giữ file này đọc được
 * một mình.
 */
interface ModuleCardCopy {
  readonly icon:
    | 'messages-square'
    | 'list-tree'
    | 'mic'
    | 'kanban'
    | 'blocks'
    | 'library'
    | 'book-open'
    | 'users'
    | 'sparkles'
    | 'search'
    | 'palette'
    | 'plug';
  readonly tint: 'brand' | 'success' | 'violet';
  readonly title: string;
  readonly body: string;
  readonly beta?: boolean;
}

const cards: readonly ModuleCardCopy[] = [
  {
    icon: 'messages-square',
    tint: 'brand',
    title: 'Chat',
    body: 'Public & private channels, rich messages, threads, reactions, attachments.',
  },
  {
    icon: 'list-tree',
    tint: 'brand',
    title: 'Topic',
    body: 'Split a channel into sub-threads, each with its own unread and mention badges.',
  },
  {
    icon: 'mic',
    tint: 'success',
    title: 'Voice',
    body: 'Always-on voice rooms inside a channel, with a floating bar to rejoin.',
  },
  {
    icon: 'kanban',
    tint: 'brand',
    title: 'Quick task management',
    body: 'Turn any channel into a Sprint, Kanban or WBS project.',
  },
  {
    icon: 'blocks',
    tint: 'brand',
    title: 'Business App',
    body: 'Project management, Training, Meeting rooms, Approvals, Tickets.',
  },
  {
    icon: 'library',
    tint: 'brand',
    title: 'Knowledge Base',
    body: 'Categorised document library with search and bookmarks.',
  },
  {
    icon: 'book-open',
    tint: 'violet',
    title: 'Wiki',
    beta: true,
    body: 'Structured internal documentation with its own editor.',
  },
  {
    icon: 'users',
    tint: 'violet',
    title: 'Co-work',
    beta: true,
    body: 'A shared real-time space where people and agents work side by side.',
  },
  {
    icon: 'sparkles',
    tint: 'brand',
    title: 'AI Agents',
    body: 'Unlimited agents: company-wide, per employee, or whitelisted per department.',
  },
  {
    icon: 'search',
    tint: 'brand',
    title: 'Search',
    body: 'One search across messages, people, documents and channels.',
  },
  {
    icon: 'palette',
    tint: 'brand',
    title: 'Design Studio',
    body: 'Design by talking to an assistant, with context drawn from the Knowledge Base.',
  },
  {
    icon: 'plug',
    tint: 'brand',
    title: 'Connectors',
    body: 'Bring external systems and data into the workspace.',
  },
];

export const modules = {
  eyebrow: 'The platform',
  heading: 'Twelve modules. One login. One source of truth.',
  lead: 'Every module shares the same members, permissions and search index — so context never has to be copied between tools.',
  cards,
};
